<template>
    <div>

        <!-- 税控上传Dialog -->
        <el-dialog title="税控上传" :visible.sync="taxControlUploadDialog" width="600px" :close-on-click-modal="false" v-dialogDrag>
            <!-- <minhead :headtitle="taxControlUploadDialogTitle" :isdiag="true"/> -->
            <div class="horizontally">
                <div style="margin-right: 100px;margin-top: 30px;">
                    <el-form :model="taxControlUploadForm" label-width="100px" :rules="taxControlUploadRules"
                             ref="taxControlUploadForm"
                             class="demo-ruleForm">
                        <el-form-item label="发票类型" prop = "invoiceType">
                            <el-select v-model="taxControlUploadForm.invoiceType" style="width: 215px;">
                                <el-option label="电子普票" value="026"/>
                                <el-option label="电子专票" value="028"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发票张数" prop = "invoiceCount">
                            <el-input v-model="taxControlUploadForm.invoiceCount" style="width: 215px;"/>
                        </el-form-item>

                    </el-form>
                </div>
            </div>
            
			<div class="buttomanniu">
				<el-button type="primary" @click="taxControlUploadConfirm">确定</el-button>
				<el-button  @click="taxControlUploadDialog=false">关闭</el-button>
			</div>
        </el-dialog>

        <minhead :headtitle="headtitle"></minhead>
        <div class="areacontent">
            <div class="between-line">
                <div class="Centerupdown">
                 <!--   <el-button type="primary" plain style="width: 100px;" @click="taxControlUploadButton">
                        税控上传
                        <i class="el-icon-upload el-icon--right"></i>
                    </el-button> -->
					<div class="addstyle" style="width: 100px; margin-right: 10px;" @click='taxControlUploadButton'>
						<samp>
						税控上传
						<i class="el-icon-upload el-icon--right"></i>
						</samp>
					</div>
                </div>
                <div class="Centerupdown">
                    <el-input style="width: 300px;margin-left: 20px;margin-right: 16px;"
                              placeholder="购方名称、发票号码、发票类型" prefix-icon="el-icon-search" v-model="likeQueryModel"
                           clearable    @input="commonQuery"></el-input>
                </div>
            </div>
            <div class="areatable">
				<div class="tableh">
                <el-table ref="multipleTable"  :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" height="calc(100vh - 292px )">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column fixed prop="shuiksczt" label="上传状态" align="center" min-width="100">
                        <template slot-scope="scope">
                            <div class="Centerhorizontally">
                                <span v-if="scope.row.shuiksczt=='0'">未上传</span>
                                <span v-if="scope.row.shuiksczt=='1'">已上传</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="faplxdm" label="发票类型" align="center"min-width="100">
                        <template slot-scope="scope">
                            <div class="Centerhorizontally">
                                <span v-if="scope.row.faplxdm=='026'">电子普票</span>
                                <span v-if="scope.row.faplxdm=='028'">电子专票</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fapdm" label="发票代码" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="faphm" label="发票号码" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="goufmc" label="购方名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="goufsbh" label="购方税号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="hejje" label="金额" align="right" min-width="110">  <template slot-scope="scope">
                            <span >{{toThousands(Amountformat(scope.row.hejje))}}</span>
                        </template></el-table-column>
                    <el-table-column prop="hejse" label="税额" align="right" min-width="110">  <template slot-scope="scope">
                            <span >{{toThousands(Amountformat(scope.row.hejse))}}</span>
                        </template></el-table-column>
                    <el-table-column prop="kaiprq" label="开票日期" align="left" min-width="160px" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="Centerhorizontally">
                                {{stringtostmp(scope.row.kaiprq)}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
				</div>
                <div class="lastend">
                    <div>当前已勾选<span>{{selectionCount}}</span>条</div>
                    <div>合计金额<span>{{selectionAmount}}</span></div>
                    <div>合计税额<span>{{selectionTaxAmount}}</span></div>
                </div>
                <div class="buttompage">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :page-sizes="[10, 20, 100, 500]"
                            :page-size="pagenum"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalcount"
                    ></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                /* 开具弹框 */
                page: 1,
                pagenum: 10,
                totalcount: 10,
                tableData: [],
                headtitle: ['抄报税管理', '税控上传'],
                taxControlUploadDialog: false,
                taxControlUploadDialogTitle: ['税控上传'],
                taxControlUploadForm: {
                    invoiceType: '',
                    invoiceCount: ''
                },
                likeQueryModel: '',
                selectionCount: 0,
                selectionAmount: 0,
                selectionTaxAmount: 0,
                taxControlUploadRules: {
                    invoiceType: [{required: true, message: '请选择发票类型', trigger: 'change'}],
                    invoiceCount: [{validator: this.validateInvoiceCount, trigger: 'blur'}]
                },
				tableHeight:""
            };
        },
        created() {
            this.commonQuery();
        },
		mounted() {
			 this.$nextTick(() =>{
				this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
				window.onresize = () =>{
			    this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
			      }
			    })
		},
        methods: {
            handleSizeChange(val) {
                this.pagenum = val;
                this.commonQuery();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.commonQuery();
            },
            handleSelectionChange(val) {
                this.selectionCount = 0;
                this.selectionAmount = 0;
                this.selectionTaxAmount = 0;
                val.forEach((item) => {
                    this.selectionCount = this.selectionCount + 1;
                    this.selectionAmount = item.hejje;
                    this.selectionTaxAmount = item.hejse;
                });
            },
            /* 通用查询 */
            commonQuery() {
                this.$https.fetchPost('tax/copy/manage/upload/query', {
                    likeSearch: JSON.parse(JSON.stringify(this.likeQueryModel)),
                    page: this.page,
                    limit: this.pagenum
                }).then(res => {
                    this.totalcount = res.data.count;
                    this.tableData = res.data.data;
                });
            },
            /* 税控上传按钮 */
            taxControlUploadButton() {
                this.taxControlUploadDialog = true;
                Object.keys(this.taxControlUploadForm).map(key => (this.taxControlUploadForm[key] = ''));
                if (this.$refs['taxControlUploadForm']) {
                    this.$nextTick(() => {
                        this.$refs['taxControlUploadForm'].clearValidate();
                    });
                }
            },
            /* 税控上传确认 */
            taxControlUploadConfirm() {
                if (!this.taxControlUploadValidate()) return;
                this.$https.fetchPost('tax/copy/manage/upload/invoice', {
                    invoiceType: this.taxControlUploadForm.invoiceType,
                    invoiceCount: this.taxControlUploadForm.invoiceCount
                }).then(res => {
                    if (res.data.success) {
                        this.commonQuery();
                        this.taxControlUploadDialog = false;
                    }
                });
            },
            taxControlUploadValidate() {
                let flag = true;
                this.$refs['taxControlUploadForm'].validate(valid => {
                    if (!valid) {
                        flag = false;
                    }
                });
                return flag;
            },
            validateInvoiceCount(rule, value, callback) {
                let reg = /^[0-9]*$/g;
                if (value === undefined || value == null || value === '') {
                    callback(new Error('请填写发票张数'));
                } else if (!reg.test(value)) {
                    callback(new Error('发票张数只能是数值'));
                } else if (value > 20) {
                    callback(new Error('最大输入值为20，如需上传数量大于20，请分批输入'));
                } else {
                    this.$refs.taxControlUploadForm.validateField('checkPass');
                }
            }
        }
    };
</script>

<style scoped="scoped" lang="less">
    // /deep/ .el-dialog__body {
    //     padding: 0;
    // }

    /deep/ .el-table--small td {
        padding: 4px 0;
    }

    /deep/ .el-table__body-wrapper {
        min-height: 160px;
    }


    .areatable {
        margin-top: 27px;
    }

    .areacontent {
        margin-left: 21px;
    }
</style>
